<select class="form-control"
        [disabled]="disabled"
        [ngClass]="{'wcm-highlight-req': required}"
        [(ngModel)]="value"
        (ngModelChange)="onChange($event)"
        (blur)="onTouched()">
  <option *ngIf="allowEmpty"></option>
  <option *ngFor="let opt of options" [value]="opt.value">{{ opt.label }}</option>
</select>
